import { DataTableColumn } from '@shared/ui/data-table';

/**
 * Функция для вычисления значения grid-template-columns для CSS Grid.
 * Она принимает массив столбцов и возвращает строку, которая может быть использована
 * в качестве значения для grid-template-columns, чтобы задать ширину каждого столбца.
 *
 * @param columns - массив объектов столбцов, каждый из которых содержит информацию о ширине и росте.
 * @returns строка, представляющая grid-template-columns.
 */
export const computeGridTemplateColumns = <T extends object>(columns: DataTableColumn<T>[]) => {
  return columns
    .map(({ width, minWidth, maxWidth, grow }) => {
      // Если задана фиксированная ширина, используем её
      if (width) {
        return `${width}px`;
      }

      // Устанавливаем минимальную ширину, если она задана, иначе 0
      const min = minWidth ? `${minWidth}px` : '0';

      // Устанавливаем максимальную ширину, если она задана, иначе 1fr (одна доля свободного пространства)
      const max = maxWidth ? `${maxWidth}px` : '1fr';

      // Если задан рост, используем minmax с ростом
      if (grow) {
        return `minmax(${min}, ${grow}fr)`;
      }

      // Если рост не задан, используем minmax с минимальной и максимальной шириной
      return `minmax(${min}, ${max})`;
    })
    .join(' ');
};
